import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@bwoty-web/styleguide';
import { sectionIcons, sectionKeys } from '../sections/helper';
import HorizontalScroll from './horizontalScroll';
import {
  getHotelSubNavScrollDistance,
  setHotelSubNavScrollDistance,
} from '../../../utils/scroll';

import './navigation.scss';

const Navigation = ({
  sections,
  selectedSection,
  selectedSectionKey,
  changeSection,
  labels,
  horizontalScrollRef,
}) => {
  const overviewSection = {
    key: sectionKeys.overview,
    name: labels.overviewHeading,
    icon: sectionIcons.overview,
  };
  const aboutHotelSection = {
    key: sectionKeys.aboutHotel,
    name: labels.descriptionHeading,
    icon: sectionIcons.aboutHotel,
  };

  const mappedSections = sections.map((section) => {
    const { key, heading } = section;
    return {
      key,
      name: heading,
      icon: sectionIcons[key],
    };
  });

  const [selectedDistance, setSelectedDistance] = useState(0);
  useEffect(() => {
    const distance = getHotelSubNavScrollDistance();
    if (distance !== selectedDistance) setSelectedDistance(distance);
    else setHotelSubNavScrollDistance(distance);
  }, [selectedSectionKey]);

  return (
    <nav className="gw-hotel-info-navigation">
      <HorizontalScroll
        stepSize={600}
        arrowGutters
        initialScroll={selectedDistance}
        ref={horizontalScrollRef}
      >
        <ul className="gw-hotel-info-navigation__list">
          {[overviewSection, aboutHotelSection, ...mappedSections].map(
            (item, i) => {
              const isActive = item.key === selectedSection;
              return (
                <li
                  key={item.key}
                  className={cx('gw-hotel-info-navigation__item', {
                    'gw-hotel-info-navigation__item--active': isActive,
                  })}
                  {...((i === 0 && { id: 'hotelInfoNavEl--first' }) ||
                    (isActive && {
                      id: 'hotelInfoNavEl--active',
                    }))}
                  {...(isActive && { 'aria-current': 'page' })}
                >
                  <button onClick={() => changeSection(item.key)} type="button">
                    <Icon path={item.icon} aria-hidden="true" />
                    <span>{item.name}</span>
                  </button>
                </li>
              );
            },
          )}
        </ul>
      </HorizontalScroll>
    </nav>
  );
};

Navigation.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      key: PropTypes.string,
    }),
  ).isRequired,
  selectedSection: PropTypes.string.isRequired,
  selectedSectionKey: PropTypes.string.isRequired,
  changeSection: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    overviewHeading: PropTypes.string,
    descriptionHeading: PropTypes.string,
  }).isRequired,
  horizontalScrollRef: PropTypes.shape({}),
};

Navigation.defaultProps = {
  horizontalScrollRef: null,
};

export default Navigation;
